import {
    getCalculatedFolderIdForDefaultCalendar,
    getCalendarEntryByEmailAddress,
} from 'owa-calendar-cache';
import type { LocalCalendarEntry, LinkedCalendarEntry } from 'owa-graph-schema';
import type MeetingMessage from 'owa-service/lib/contract/MeetingMessage';
import { getUserMailboxInfo } from 'owa-client-ids';

/**
 * Retrieves the Calendar Folder Id for a given MeetingRequest message
 * @param item The item
 * Remarks: Calling this method requires the Calendar's cache initialization to be completed.
 */
export default function getCalendarFolderId(item: MeetingMessage) {
    let ownerEmailAddress;
    const isDelegateScenario = !!item.IsDelegated && !!item.ReceivedRepresenting;
    if (!isDelegateScenario) {
        ownerEmailAddress = getUserMailboxInfo().userIdentity;
        return getCalculatedFolderIdForDefaultCalendar(ownerEmailAddress);
    } else {
        ownerEmailAddress = item.ReceivedRepresenting.Mailbox.EmailAddress;
        const calendarEntry = getCalendarEntryByEmailAddress(ownerEmailAddress);
        if (calendarEntry) {
            if ((<LinkedCalendarEntry>calendarEntry).SharedFolderId) {
                return (<LinkedCalendarEntry>calendarEntry).SharedFolderId.Id;
            }
            if ((<LocalCalendarEntry>calendarEntry).FolderId) {
                return (<LocalCalendarEntry>calendarEntry).FolderId.Id;
            }
        }

        return null;
    }
}
